module.exports = __webpack_public_path__ + "img/area-8-3.761be42.jpg";